'use strict';

/* globals jQuery yith yithStripePayments */

import { $, labels } from '../../../src/globals';
import OnboardingButton from './OnboardingButton';
import AjaxHandler from '../../../src/modules/ajax';

/**
 * Class that handles Onboarding button interactions
 */
export default class OnboardingWidget {
	/**
	 * jQuery wrapper element.
	 */
	$wrapper;

	/**
	 * jQuery connect button element
	 */
	$connectButton;

	/**
	 * jQuery refresh button element
	 */
	$refreshButton;

	/**
	 * jQuery revoke button element
	 */
	$revokeButton;

	/**
	 * Constructor method
	 *
	 * @param {jQuery} $el object jQuery reference to onboarding button node
	 */
	constructor( $el ) {
		this.$wrapper = $el;
		this.$connectButton = this.$wrapper
			.find( '.yith-stripe-payments__onboarding__button' )
			.add( '.yith-stripe-payments__onboarding__continue' );
		this.$refreshButton = this.$wrapper.find(
			'.yith-stripe-payments__onboarding__refresh'
		);
		this.$revokeButton = this.$wrapper.find(
			'.yith-stripe-payments__onboarding__revoke'
		);

		this.init();
	}

	/**
	 * Init events specific of this object
	 */
	init() {
		this.$connectButton.length &&
			this.$connectButton.each(
				( i, el ) => new OnboardingButton( $( el ) )
			);

		this.$refreshButton.length &&
			this.$refreshButton.on( 'click', ( ev ) => {
				ev.preventDefault();
				this.refresh();
			} );

		this.$revokeButton.length &&
			this.$revokeButton.on( 'click', ( ev ) => {
				ev.preventDefault();
				this.revoke();
			} );
	}

	refresh() {
		AjaxHandler.post
			.call(
				this.$refreshButton,
				'refresh_connection_status',
				'refresh_connection_status'
			)
			.then( () => window.location.reload() );
	}

	revoke() {
		const modalClass = 'yith-stripe-payments__onboarding__revoke-modal';

		yith.ui.confirm( {
			title: labels.confirm_revoke_title,
			message: labels.confirm_revoke_message,
			confirmButton: labels.confirm_revoke_button,
			confirmButtonType: 'delete',
			closeAfterConfirm: false,
			classes: {
				wrap: modalClass,
			},
			onConfirm() {
				AjaxHandler.post
					.call(
						$( `.${ modalClass } > .yith-plugin-fw__modal__main` ),
						'revoke_connection',
						'revoke_connection'
					)
					.then( () => window.location.reload() );
			},
		} );
	}
}
